import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import ImageToutSideBySide, { IMAGE_HORIZONTAL_ALIGNMENTS, IMAGE_SIZES, IMAGE_VERTICAL_ALIGNMENTS } from '@root/joinroot.com/src/components/sections/image-tout/image-tout-side-by-side';
import LinkButton from '@root/joinroot.com/src/models/link-button';
import PropTypes from '@root/vendor/prop-types';
import renderRichText from '@root/joinroot.com/src/utils/render-rich-text';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { constantize } from '@root/core/src/utils/strings';

export default function ImageToutSideBySideBlock({ content }) {
  const { imageTout } = content;

  const { trackClick } = useAnalytics(`IMAGE_TOUT_SIDE_BY_SIDE_${content.id}`, false);

  return (
    <div data-testid={'imageToutSideBySideBlock'}>
      <ImageToutSideBySide
        backgroundColor={BackgroundColors.getDefaultedString(content.backgroundColor)}
        body={renderRichText(imageTout.body)}
        button={buildButton(imageTout.callToActionButton)}
        eyebrow={imageTout.eyebrow}
        image={imageTout.asset}
        imageAltText={imageTout.imageAltText}
        imageFullBleed={isImageFullBleed(content.imageSize)}
        imageHorizontalAlignment={buildImageHorizontalAlignment(content.imageAlignment)}
        imageSize={buildImageSize(content.imageSize)}
        imageVerticalAlignment={buildImageVerticalAlignment(content.verticalImageAlignment)}
        title={imageTout.headline}
        trackClick={trackClick}
      />
    </div>
  );
}

ImageToutSideBySideBlock.propTypes = {
  content: PropTypes.shape({
    backgroundColor: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    imageAlignment: PropTypes.string.isRequired,
    verticalImageAlignment: PropTypes.string,
    imageSize: PropTypes.string,
    imageTout: PropTypes.shape({
      callToActionButton: PropTypes.object,
      body: PropTypes.object,
      eyebrow: PropTypes.string,
      headline: PropTypes.string,
      asset: PropTypes.object,
      imageAltText: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

function isImageFullBleed(imageSize) {
  if (!imageSize) { return false; }

  return imageSize.toLowerCase().includes('full-bleed');
}

function buildImageSize(imageSize) {
  if (isImageFullBleed(imageSize)) { return null; }

  return imageSize.toLowerCase() === 'small' ? IMAGE_SIZES.SMALL : IMAGE_SIZES.MEDIUM;
}

function buildImageHorizontalAlignment(imageAlignment) {
  return imageAlignment.toLowerCase().includes('left') ? IMAGE_HORIZONTAL_ALIGNMENTS.LEFT : IMAGE_HORIZONTAL_ALIGNMENTS.RIGHT;
}

function buildImageVerticalAlignment(imageAlignment) {
  if (!imageAlignment) { return IMAGE_VERTICAL_ALIGNMENTS.CENTER; }

  return imageAlignment.toLowerCase().includes('center') ? IMAGE_VERTICAL_ALIGNMENTS.CENTER : IMAGE_VERTICAL_ALIGNMENTS.TOP;
}

function buildButton(button) {
  if (!button) { return; }

  return {
    id: button.id,
    type: LinkButton.types[constantize(button.buttonType)],
    text: button.buttonText,
    link: button.buttonLink,
  };
}

